import { useQuery } from '@tanstack/react-query';
import { OutageNotificationsClient } from '@@/api/api-outage-notifications';

export const useActiveBanner = (page?: string) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['active-banner', page || 'none'],
    queryFn: async () => {
      if (!page) return null;
      const client = new OutageNotificationsClient();
      const result = await client.getActiveBanner(page);
      if (!result.ok) return null;
      return result.data;
    },
    enabled: !!page,
    refetchOnWindowFocus: false
  });

  return {
    banner: data ?? null,
    isLoading,
    error: error instanceof Error ? error.message : null
  };
};
